import React from 'react';

const PlusIcon = ({ inverted = false }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.277344 5.5H12.7246V7.5H0.277344V5.5Z" fill="#222222" />
      <path
        d="M7.5 0.276367L7.5 12.7236H5.5L5.5 0.276367L7.5 0.276367Z"
        fill="#222222"
        opacity={inverted ? '0' : '1'}
      />
    </svg>
  );
};

export default PlusIcon;
